module.exports = __webpack_public_path__ + "static/fonts/SourceSansPro-Italic.8be7d41.eot";